module.exports = __webpack_public_path__ + "img/banner1_2.5e839e16.png";